import React, { useState } from "react";
import Dropdown from "../../components/CustomFields/Dropdown";
import InputField from "../../components/CustomFields/InputField"; // Import InputField

const AdditionalDetails = ({ applicant, handleNestedChange ,error}) => {
  // State for selected "How did you hear about Velammal"
  const [selectedHearAboutUs, setSelectedHearAboutUs] = useState(
    applicant.dynamicAttributes.find(
      (attr) => attr.name === "How did you know about Velammal"
    )?.value || ""
  );

  // State to manage the "Other" field visibility
  const [showOtherField, setShowOtherField] = useState(false);

  // State for the "Other" field input
  const [otherFieldValue, setOtherFieldValue] = useState("");

  // Handle "How did you hear about Velammal" dropdown change
  const handleHearAboutUsChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedHearAboutUs(selectedValue);

    // Check if "Other" is selected
    if (selectedValue === "Other") {
      setShowOtherField(true);
      setOtherFieldValue(""); // Reset the "Other" field value
    } else {
      setShowOtherField(false);
    }

    // Update the dynamicAttributes in the parent component
    handleNestedChange(
      "dynamicAttributes",
      applicant.dynamicAttributes.findIndex(
        (attr) => attr.name === "How did you know about Velammal"
      ),
      "value",
      selectedValue
    );
  };

  // Handle "Other" field change
  const handleOtherFieldChange = (e) => {
    const otherValue = e.target.value;
    setOtherFieldValue(otherValue);

    // Update the dynamicAttributes in the parent component if "Other" is selected
    if (selectedHearAboutUs === "Other") {
      handleNestedChange(
        "dynamicAttributes",
        applicant.dynamicAttributes.findIndex(
          (attr) => attr.name === "How did you know about Velammal"
        ),
        "value",
        otherValue
      );
    }
  };

  return (
    <section>
      <h2 className="text-lg font-bold mb-4 text-center">Additional Details</h2>
         {/* "How did you hear about Velammal" Dropdown */}
         <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
         <Dropdown
            id="hearAboutUs"
            label="How did you hear about Velammal?"
            value={selectedHearAboutUs}
            onChange={handleHearAboutUsChange}
            options={["News", "Advertisement", "Facebook", "Other"]} // Add "Other" option
            defaultOption="Select an option"
          />

          {/* "Other" field */}
          {showOtherField && (
            <InputField
              id="otherHearAboutUs"
              label="Specify Other"
              value={otherFieldValue}
              onChange={handleOtherFieldChange}
              //placeholder="Enter other option"
            />
          )}
        </div>
     
    </section>
  );
};

export default AdditionalDetails;